import { Box, Grid, Typography, Link } from '@mui/material'
import Paper from '@mui/material/Paper/Paper'
import React, { useState, useEffect } from 'react'

type Props = {
  post: {
    description: string[],
    image: string,
    imageText: string,
    linkText: string[],
    title: string[],
    url: string
  }
}

function MainFeaturedPost({ post }: Props) {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    if (
      post.description.length <= 1
      && post.linkText.length <= 1
      && post.title.length <= 1
    ) return;

    const maxLen = Math.max(
      post.description.length,
      post.linkText.length,
      post.title.length
    );
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % maxLen);
        setFade(true);
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, [post.description.length, post.linkText.length, post.title.length]);

  return (
    <Paper
      sx={{
        position: 'relative',
        backgroundColor: 'grey.900',
        color: '#fff',
        mb: 4,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url(${post.image})`,
        height: '20em'
      }}
    >
      {/* Increase the priority of the hero background image */}
      {<img style={{ display: 'none' }} src={post.image} alt={post.imageText} />}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backgroundColor: 'rgba(0,0,0,.5)',
        }}
      />
      <Grid container>
        <Grid item md={6}>
          <Box
            sx={{
              position: 'relative',
              p: { xs: 3, md: 6, xl: 6 },
              pr: { md: 0 },
            }}
          >
            <Box sx={{ opacity: fade ? 1 : 0, transition: 'opacity 0.5s ease-in-out' }}>
              <Typography component="h1" variant="h3" color="inherit" gutterBottom>
                {post.title[index % Math.max(1, post.title.length)]}
              </Typography>
              <Typography variant="h5" color="inherit" paragraph>
                {post.description[index % Math.max(1, post.description.length)]}
              </Typography>
              <Link variant="subtitle1" href={post.url}>
                {post.linkText[index % Math.max(1, post.linkText.length)]}
              </Link>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default MainFeaturedPost